const botafogo = [
  {
    id: 86,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Blusa Preta ",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "blusa",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-00-m/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-00-m/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-00-m/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-00-m/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-00-m/botafogo4.jpg",
    ],
  },
  {
    id: 87,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme 1",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-01/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-01/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-01/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-01/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-01/botafogo4.jpg",
    ],
  },
  {
    id: 88,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme 2",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-02/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02/botafogo4.jpg",
    ],
  },
  {
    id: 89,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme 2 (Feminino)",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2026",
      "botafogo feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-02-f/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02-f/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02-f/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02-f/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02-f/botafogo4.jpg",
    ],
  },
  {
    id: 90,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme 2 Manga Longa",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-02-mc/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02-mc/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02-mc/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02-mc/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-02-mc/botafogo4.jpg",
    ],
  },
  {
    id: 91,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme 3",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-03/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-03/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-03/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-03/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-03/botafogo4.jpg",
    ],
  },
  {
    id: 92,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme de Goleiro (Azul)",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-04-ga/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-04-ga/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-04-ga/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-04-ga/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-04-ga/botafogo4.jpg",
    ],
  },
  {
    id: 93,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme de Goleiro (Verde)",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-04-gv/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-04-gv/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-04-gv/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-04-gv/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-04-gv/botafogo4.jpg",
    ],
  },
  {
    id: 94,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme Edição Especial (Roxa)",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-05-es/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-05-es/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-05-es/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-05-es/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-05-es/botafogo4.jpg",
    ],
  },
  {
    id: 95,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme de Pré Treino (Branca)",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-06-pt/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-06-pt/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-06-pt/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-06-pt/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-06-pt/botafogo4.jpg",
    ],
  },
  {
    id: 96,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme de Treino (Roxa)",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-06-tr/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-06-tr/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-06-tr/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-06-tr/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-06-tr/botafogo4.jpg",
    ],
  },
  {
    id: 97,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme de Pré jogo (Roxa)",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-07-pjr/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-07-pjr/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-07-pjr/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-07-pjr/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-07-pjr/botafogo4.jpg",
    ],
  },
  {
    id: 98,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 25/26 Uniforme de Pré Treino (Verde)",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/25-26-08-ptv/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/25-26-08-ptv/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/25-26-08-ptv/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/25-26-08-ptv/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/25-26-08-ptv/botafogo4.jpg",
    ],
  },
  {
    id: 99,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 24/25 Uniforme 1",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/24-25-01/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/24-25-01/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/24-25-01/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/24-25-01/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/24-25-01/botafogo4.jpg",
    ],
  },
  {
    id: 100,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 24/25 Uniforme 1 (Feminino)",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2025",
      "botafogo feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/24-25-01-f/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/24-25-01-f/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/24-25-01-f/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/24-25-01-f/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/24-25-01-f/botafogo4.jpg",
    ],
  },
  {
    id: 101,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 24/25 Uniforme 1 Manga Longa",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/24-25-01-mc/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/24-25-01-mc/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/24-25-01-mc/botafogo2.jpg",
    ],
  },
  {
    id: 102,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 24/25 Uniforme 2 ",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/24-25-02/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02/botafogo4.jpg",
    ],
  },
  {
    id: 103,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 24/25 Uniforme 2 (Feminino) ",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2025",
      "botafogo feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/24-25-02-f/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-f/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-f/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-f/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-f/botafogo4.jpg",
    ],
  },
  {
    id: 104,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 24/25 Uniforme 2 Manga Longa",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/24-25-02-mc/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-mc/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-mc/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-mc/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-mc/botafogo4.jpg",
    ],
  },
  {
    id: 105,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 24/25 Regata Preta",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2025",
      "regata do botafogo",
      "regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/24-25-02-r/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-r/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-r/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-r/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/24-25-02-r/botafogo4.jpg",
    ],
  },
  {
    id: 106,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 24/25 Uniforme Edição Especial",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2025",
      "botafogo edição especial",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/24-25-04/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/24-25-04/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/24-25-04/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/24-25-04/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/24-25-04/botafogo4.jpg",
    ],
  },
  {
    id: 107,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 24/25 Uniforme de Goleiro (Verde)",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/24-25-04-gv/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/24-25-04-gv/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/24-25-04-gv/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/24-25-04-gv/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/24-25-04-gv/botafogo4.jpg",
    ],
  },
  {
    id: 108,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 24/25 Uniforme Edição Especial (Amarela)",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2025",
      "botafogo edição especial",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/24-25-05-a/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/24-25-05-a/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/24-25-05-a/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/24-25-05-a/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/24-25-05-a/botafogo4.jpg",
    ],
  },
  {
    id: 109,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 23/24 Blusa Branca",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2024",
      "blusa do botafogo",
      "blusa",
    ],
    tipo: "masculino",
    categoria: "blusa",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/23-24-00-bb/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-bb/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-bb/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-bb/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-bb/botafogo4.jpg",
    ],
  },
  {
    id: 110,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 23/24 Blusa Preta",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2024",
      "blusa do botafogo",
      "blusa",
    ],
    tipo: "masculino",
    categoria: "blusa",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/23-24-00-bp/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-bp/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-bp/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-bp/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-bp/botafogo4.jpg",
    ],
  },
  {
    id: 111,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 23/24 Jaqueta Preta ",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2024",
      "jaqueta do botafogo",
      "jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/23-24-00-jp/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-jp/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-jp/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-jp/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/23-24-00-jp/botafogo4.jpg",
    ],
  },
  {
    id: 112,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 23/24 Uniforme 1 ",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/23-24-01/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/23-24-01/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/23-24-01/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/23-24-01/botafogo3.jpg",
    ],
  },
  {
    id: 113,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 23/24 Uniforme 2 ",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/23-24-02/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/23-24-02/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/23-24-02/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/23-24-02/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/23-24-02/botafogo4.jpg",
    ],
  },
  {
    id: 114,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 22/23 Uniforme 2",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/22-23-02/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/22-23-02/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/22-23-02/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/22-23-02/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/22-23-02/botafogo4.jpg",
    ],
  },
  {
    id: 115,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 22/23 Uniforme 3",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/22-23-03/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/22-23-03/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/22-23-03/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/22-23-03/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/22-23-03/botafogo4.jpg",
    ],
  },
  {
    id: 116,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 21/22 Uniforme 1 ",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/21-22-01/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/21-22-01/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/21-22-01/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/21-22-01/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/21-22-01/botafogo4.jpg",
    ],
  },
  {
    id: 117,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 21/22 Uniforme 2",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/21-22-02/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/21-22-02/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/21-22-02/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/21-22-02/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/21-22-02/botafogo4.jpg",
    ],
  },
  {
    id: 118,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 21/22 Uniforme 3 ",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/21-22-03/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/21-22-03/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/21-22-03/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/21-22-03/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/21-22-03/botafogo4.jpg",
    ],
  },
  {
    id: 119,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 21/22 Uniforme de Pré Jogo (Azul) ",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/21-22-04-pja/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/21-22-04-pja/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/21-22-04-pja/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/21-22-04-pja/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/21-22-04-pja/botafogo4.jpg",
    ],
  },
  {
    id: 120,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 21/22 Uniforme de Pré Jogo (Preta) ",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/21-22-05-pjp/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/21-22-05-pjp/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/21-22-05-pjp/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/21-22-05-pjp/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/21-22-05-pjp/botafogo4.jpg",
    ],
  },
  {
    id: 121,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 20/21 Edição Especial Conciência Negra",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2021",
      "botafogo edição especial",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/20-21-00-es-cn/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/20-21-00-es-cn/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/20-21-00-es-cn/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/20-21-00-es-cn/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/20-21-00-es-cn/botafogo4.jpg",
    ],
  },
  {
    id: 122,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 20/21 Uniforme 1 ",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/20-21-01/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/20-21-01/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/20-21-01/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/20-21-01/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/20-21-01/botafogo4.jpg",
    ],
  },
  {
    id: 123,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 20/21 Uniforme 1 (Feminino) ",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2021",
      "botafogo feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/20-21-01-f/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/20-21-01-f/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/20-21-01-f/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/20-21-01-f/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/20-21-01-f/botafogo4.jpg",
    ],
  },
  {
    id: 124,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 19/20 Uniforme 1 ",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2020"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/19-20-01/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/19-20-01/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/19-20-01/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/19-20-01/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/19-20-01/botafogo4.jpg",
    ],
  },
  {
    id: 125,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 19/20 Uniforme 2",
    aliases: ["botafogo", "fogão", "bota", "botafogo rj", "botafogo 2020"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/botafogo/19-20-02/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/19-20-02/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/19-20-02/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/19-20-02/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/19-20-02/botafogo4.jpg",
    ],
  },
  {
    id: 126,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 96/97 Uniforme 1 Retro",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2024",
      "retro",
      "retro botafogo",
      "botafogo retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/96-97-01-rt/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/96-97-01-rt/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/96-97-01-rt/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/96-97-01-rt/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/96-97-01-rt/botafogo4.jpg",
    ],
  },
  {
    id: 127,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 95/96 Uniforme 2 Retro",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2024",
      "retro",
      "retro botafogo",
      "botafogo retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/95-96-02-rt/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/95-96-02-rt/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/95-96-02-rt/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/95-96-02-rt/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/95-96-02-rt/botafogo4.jpg",
    ],
  },
  {
    id: 128,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 95/96 Uniforme 3 Retro",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2024",
      "retro",
      "retro botafogo",
      "botafogo retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/95-96-03-rt/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/95-96-03-rt/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/95-96-03-rt/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/95-96-03-rt/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/95-96-03-rt/botafogo4.jpg",
    ],
  },
  {
    id: 129,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 94/95 Uniforme 1 Retro",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2024",
      "retro",
      "retro botafogo",
      "botafogo retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/94-95-01-rt/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/94-95-01-rt/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/94-95-01-rt/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/94-95-01-rt/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/94-95-01-rt/botafogo4.jpg",
    ],
  },
  {
    id: 130,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 94/95 Uniforme 2 Retro",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2024",
      "retro",
      "retro botafogo",
      "botafogo retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/94-95-02-rt/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/94-95-02-rt/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/94-95-02-rt/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/94-95-02-rt/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/94-95-02-rt/botafogo4.jpg",
    ],
  },
  {
    id: 131,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 92/93 Uniforme 1 Retro",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2024",
      "retro",
      "retro botafogo",
      "botafogo retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/92-93-01-rt/botafogo0.jpeg",
      "/images/brasil/serie-a/botafogo/92-93-01-rt/botafogo1.jpeg",
      "/images/brasil/serie-a/botafogo/92-93-01-rt/botafogo2.jpeg",
      "/images/brasil/serie-a/botafogo/92-93-01-rt/botafogo3.jpeg",
      "/images/brasil/serie-a/botafogo/92-93-01-rt/botafogo4.jpeg",
    ],
  },
  {
    id: 132,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 93/94 Uniforme 1 Retro",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2024",
      "retro",
      "retro botafogo",
      "botafogo retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/93-94-01-rt/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/93-94-01-rt/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/93-94-01-rt/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/93-94-01-rt/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/93-94-01-rt/botafogo4.jpg",
    ],
  },
  {
    id: 133,
    pais: "brasil",
    liga: "serie-a",
    time: "botafogo",
    nome: "Botafogo 93/94 Uniforme 2 Retro",
    aliases: [
      "botafogo",
      "fogão",
      "bota",
      "botafogo rj",
      "botafogo 2024",
      "retro",
      "retro botafogo",
      "botafogo retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/botafogo/93-94-02-rt/botafogo0.jpg",
      "/images/brasil/serie-a/botafogo/93-94-02-rt/botafogo1.jpg",
      "/images/brasil/serie-a/botafogo/93-94-02-rt/botafogo2.jpg",
      "/images/brasil/serie-a/botafogo/93-94-02-rt/botafogo3.jpg",
      "/images/brasil/serie-a/botafogo/93-94-02-rt/botafogo4.jpg",
    ],
  },
];

export default botafogo;
